import React, {useState, useEffect} from "react";
import {useTitleFromComponent, useDataWithRoute} from "../../../../utils/hooks";
import {useVsiAppContext} from "../../../../stores/VsiApp";
import {useSearchParams} from "react-router-dom";
import {VsiBubble, VsiH4,} from "../../../../styled/App.styled";
import {Card, Spinner} from "reactstrap";
import Grid from "../../../../components/Grid";
import {provisioningColorsNoSnap, formatBarData} from "../../../../utils/chartUtils";
import StackedColumnChart from "../../../../components/StackedColumnChart";
import {dateFormatter, numberFormatter} from "../../../../utils/gridFormatters";

const columnDefs = [
    {
        "field": "collection_date",
        "headerName": "Collection Date",
        "cellRenderer": dateFormatter
    },
    {
        "field": "pool_name",
        "headerName": "Pool Name"
    },
    {
        "field": "pool_used_gb",
        "type": "numericColumn",
        "headerName": "Pool Used",
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
        "allowedAggFuncs": [
            "sum"
        ],
        "cellRenderer": numberFormatter,
    },
    {
        "field": "prov_free_gb",
        "type": "numericColumn",
        "headerName": "Provisioned Free",
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
        "allowedAggFuncs": [
            "sum"
        ],
        "cellRenderer": numberFormatter,
    },
    {
        "field": "unprov_free_gb",
        "type": "numericColumn",
        "headerName": "Unprovisioned Free",
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
        "allowedAggFuncs": [
            "sum"
        ],
        "cellRenderer": numberFormatter,
    },
    {
        "field": "over_prov_gb",
        "type": "numericColumn",
        "headerName": "Overprovisioned",
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
        "allowedAggFuncs": [
            "sum"
        ],
        "cellRenderer": numberFormatter,
    }
];

const sortingArr = ['Overprovisioned', 'Unprovisioned Free', 'Provisioned Free', 'Pool Used'];

export default function DeviceProvisioning({context, title}) {

    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();

    const [searchParams] = useSearchParams();
    const [barData, setBarData] = useState({
        categories: [],
        series: []
    });
    const [allData, setAllData] = useState([]);

    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/device_provisioning_proc?client_id=${client.clientId}&period_id=${periodId}&device_name=${encodeURIComponent(searchParams.get('device_name'))}`)

    useEffect(() => {
        const validData = data?.recordset || [];
        setAllData(validData);
        updateChartWithSelection(validData);
    }, [data]);

    const updateChartWithSelection = data => {
        setBarData(formatBarData(data || allData, {
            sortingArr,
            sortingField: 'pool_name',
            defs: columnDefs.filter(def => sortingArr.includes(def.headerName)),
        }));
    };

    const filterChanged = (eventData) => {
        let filteredData = [];
        eventData.api.forEachNodeAfterFilter(node => {
            if(node.data) filteredData.push(node.data);
        });

        updateChartWithSelection(filteredData);
    };

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Provisioning Report - {searchParams.get("device_name")}</VsiH4>
        {isLoading ? <Spinner color={"primary"}/> : (
            <div>
                <VsiBubble>
                    <StackedColumnChart categories={barData.categories}
                                        colors={provisioningColorsNoSnap}
                                        height={775}
                                        series={barData.series}/>
                </VsiBubble>
                <VsiBubble>
                    <Grid data={allData}
                          filterChanged={filterChanged}
                          columnDefs={columnDefs}/>
                </VsiBubble>
            </div>
        )}
    </Card>
}
